import '../pages.css';
import { Link } from 'react-router-dom';

const FCZScrewRetainedHybridCrown = () => {
    return (
        <div className="page product-detail">
            <section className="product-detail-hero">
                <div className="product-detail-hero-content">
                    <Link to="/products/implants" className="back-link">← Back to Implants/Hybrid</Link>
                    <h1>FCZ Screw-Retained Hybrid Crown</h1>
                    <p className="product-tagline">Maximize implant longevity and clinical success</p>
                </div>
            </section>

            <section className="product-detail-content">
                <div className="content-container">
                    <div className="product-section">
                        <h2>Description</h2>
                        <p>
                            Full-contour zirconia screw-retained hybrid crowns from <strong>AbELab</strong> are designed to maximize implant
                            longevity and clinical success. By eliminating the use of cement at the abutment interface, this restoration
                            significantly reduces the risk of peri-implant complications caused by residual cement. The crown is secured directly
                            to the abutment with a screw, allowing for easy, noninvasive retrievability when maintenance or modification is required.
                            The screw access channel is sealed with composite and opaquer materials, ensuring excellent esthetics without
                            compromising function.
                        </p>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default FCZScrewRetainedHybridCrown;
